import { createStore } from 'owa-satcheljs';
import type CopilotPrioritizeSettings from '../types/CopilotPrioritizeSettings';
import type CopilotStyleSettings from '../types/CopilotStyleSettings';
interface CopilotPrioritizeSettingsStore {
    isInitialized: boolean;
    settings: CopilotPrioritizeSettings;
    version: number;
}

interface CopilotStyleSettingsStore {
    isInitialized: boolean;
    settings: CopilotStyleSettings;
}

export interface GeneralPreferences {
    isCopilotUIDisabled: boolean; // true if the user chooses to disable Copilot UI which will hide all Copilot entrypoint UIs, but not affect teaching moments
}

// Temporarily, userDefinedTopics will be a string that can be parsed as JSON.
// It will have the following structure:
/*
{
    "userDefinedTopics": ["Topic1", "Topic2", ...],
    "systemGeneratedTopics": ["SystemTopic1", "SystemTopic2", ...]
}
*/
export interface TopicsPreferences {
    userDefinedTopics: string | null;
}

interface CopilotSettingsStoreMap {
    copilotPrioritizeSettingsStoreMap: Map<string, CopilotPrioritizeSettingsStore>;
    copilotStyleSettingsStoreMap: Map<string, CopilotStyleSettingsStore>;
    copilotGeneralPreferencesMap: Map<string, GeneralPreferences>;
    copilotTopicsPreferencesMap: Map<string, TopicsPreferences>;
}

const defaultExport: () => CopilotSettingsStoreMap = createStore<CopilotSettingsStoreMap>(
    'copilotSettingsStore',
    {
        copilotPrioritizeSettingsStoreMap: new Map(),
        copilotStyleSettingsStoreMap: new Map(),
        copilotGeneralPreferencesMap: new Map(),
        copilotTopicsPreferencesMap: new Map(),
    }
);
export default defaultExport;
